export default "__VITE_ASSET__B_TCoCnv__"